var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['page', { isOld: _vm.isOld == 1 ? true : false }]},[_c('div',{staticClass:"title"},[_vm._v("支付成功")]),_c('img',{attrs:{"src":require("./img/success.png")}}),_c('div',{staticClass:"content"},[_c('span',[_vm._v("订单号：")]),_vm._v(_vm._s(_vm.code))]),_c('div',{staticClass:"btn",on:{"click":_vm.goback}},[_vm._v("继续点单")])])
}
var staticRenderFns = []

export { render, staticRenderFns }